import { APP_ORIGIN } from '@/lib/config/app-install'

/**
 * Pure base-URL helper for React Email templates.
 *
 * Kept separate from lib/email/shared.ts so that template components don't
 * transitively import createAdminClient or the app logger. Returns the canonical
 * site URL with trailing slashes stripped.
 */
export function getEmailBaseUrl(): string {
  return (process.env.NEXT_PUBLIC_BASE_URL || 'https://alumnia.net').replace(/\/+$/, '')
}

/**
 * The app origin for the links that send a person into the product to sign up
 * (invitations, reminders, onboarding). In production it is fixed on purpose: it
 * does not read NEXT_PUBLIC_BASE_URL, so a wrong or unreadable value there cannot
 * send an invitation to a host the apps do not open. Other emails keep
 * `getEmailBaseUrl()`.
 */
export function getAppEmailBaseUrl(): string {
  // Only in production: on staging, a preview or a local run the token belongs to
  // that environment, so the link must point back at it (APP_ENV is the same
  // variable the deployment attestation reads). If APP_ENV is missing the link falls
  // back to NEXT_PUBLIC_BASE_URL, which is how it behaved before this helper.
  return process.env.APP_ENV === 'production' ? APP_ORIGIN : getEmailBaseUrl()
}
